<template>
    <footer class="main-footer bg-primary text-white py-4">
        <div class="container">
        <div class="row">
          <div class="col-md-4 mb-4 mb-md-0">
            <h5>À Propos</h5>
            <p>Une brève description de ton site ou de ton entreprise.</p>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <h5>Liens Rapides</h5>
            <ul class="list-unstyled">
              <li><a href="#" class="text-white">Accueil</a></li>
              <li><a href="#" class="text-white">À Propos</a></li>
              <li><a href="#" class="text-white">Services</a></li>
              <li><a href="#" class="text-white">Contact</a></li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <h5>Contact</h5>
            <ul class="list-unstyled">
              <li><i class="fas fa-map-marker-alt"></i> 123 Rue de l'Exemple, Ville</li>
              <li><i class="fas fa-phone"></i> +123 456 7890</li>
              <li><i class="fas fa-envelope"></i> contact@example.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4">
        <div class="row">
          <div class="col-12 text-center">
            <p class="mb-0">&copy; 2023 Mon Site. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  </template>
  
  <style scoped>
  .main-footer {
    /* Pas besoin de position absolue */
    width: 100%;
  }
  </style>
  